import React from "react";
import { Route, Routes } from "react-router-dom";
import DownloaderReportList from "../../../components/reports/downloader/DownloaderReportList";

const DownloaderRoute = () => {
  return (
    <Routes>
      <Route path="/" element={<DownloaderReportList />} />
    </Routes>
  );
};

export default DownloaderRoute;
